import { toast } from "react-toastify";

export const controlJSON = (tryJSON: string): boolean => {
    try {
        JSON.parse(tryJSON);
        return true;
    } catch {
        toast.error("Invalid JSON");
        return false;
    }
};
